import Cookie from "cookie-universal";

const cookie = Cookie();
const TOKEN_KEY = "target-wiki-token";

export const getToken = () => cookie.get(TOKEN_KEY) || null;
export const setSession = (token) => token && cookie.set(TOKEN_KEY, token);
export const clearSession = () => cookie.remove(TOKEN_KEY);
